import React from 'react'
import InventoryForm from './RequisitionComponents/OsRequisitionInventoryForm';
 
const OsrRequisitionPull = () => {
  return (
    <div>
      <InventoryForm permissionType="PULL" />
    </div>
  )
}

export default OsrRequisitionPull
